const messages = {
  allreadyReviewed: 'You have already reviewed this listing.',
  reviewSubmitted: 'Your review has been submitted.',
  reviewError: 'There was an error submitting your review.',
  ownershipRequested:
    'Your request has been submitted. A NUGL representative will contact you within 24 hours to verify ownership of this business.',
  ownershipError: 'There was an error submitting your claim form.',
}

export default messages



// WEBPACK FOOTER //
// ./src/components/listings/Page/messages.js